import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [selected, setSelected] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (!value) return;
    setSelected(value);
    const category = categories.find((c) => c.name === value);
    if (category) {
      window.open(category.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
          Browse by Category
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-6">
          Select a category below to explore our curated Sugargoo spreadsheet finds
        </p>
        <div className="relative">
          <select
            value={selected}
            onChange={handleChange}
            className="w-full appearance-none bg-background-50 border border-background-300 rounded-xl px-5 py-3.5 text-sm text-foreground-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all"
          >
            <option value="">-- Choose a Category --</option>
            {categories.map((cat) => (
              <option key={cat.name} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
            <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
          </div>
        </div>
      </div>
    </section>
  );
}